import Config from '../config'
import { AxiosInstance } from '../helpers/AxiosInstance'


const getFalkonEsignTemplates = (orgId: string) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkondocs/api/v1/templates/org/${orgId}`)
}

const sendFalkonEsignTemplateForSigning = (templateId: string,
    data: {
        recipients: {
            order_number: number,
            email: string,
            phone_number: string,
            name: string,
            type: string
        }[],
        first_name: string,
        last_name: string,
        organization_id: string,
        phone_number_id: string,
        phone_number: string,
        organization_name: string,
    }) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/templates/send/${templateId}`, data as any)
}

export const FalkonEsignTemplateService = {
    getFalkonEsignTemplates,
    sendFalkonEsignTemplateForSigning
}